import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { localize, ValidationProvider } from 'vee-validate'
import { localize as localizeFull, ValidationProvider as FullValidationProvider } from 'vee-validate/dist/vee-validate.full'
import { languages, languageStorageKey } from './languages'

Vue.use(VueI18n)

const localeFiles = require.context('./locales', false, /\.json$/)
const messages = {}
languages.forEach(({ code }) => {
  messages[code] = localeFiles(`./${code}.json`)
})
// Existing forms use both vee-validate builds; keep their dictionaries in sync.
const validationMessages = Object.fromEntries(languages.map(({ code }) => [code, { messages: messages[code].validation || messages.en.validation }]))
localize(validationMessages)
localizeFull(validationMessages)

// Vee-validate regenerates messages with the old field name on locale changes.
// Revalidate touched fields after their translated name prop has updated.
const validationProviders = [ValidationProvider, FullValidationProvider]
validationProviders.forEach(provider => {
  provider.mixin({
    watch: {
      name() {
        if (this.flags.validated) this.$nextTick(() => this.validate())
      },
    },
  })
})

export function supportedLocale(locale) {
  // Preserve preferences saved before the regional variants were confirmed.
  const aliases = { es: 'es-ES', pt: 'pt-PT' }
  const selectedLocale = aliases[locale] || locale
  return languages.some(language => language.code === selectedLocale) ? selectedLocale : 'en'
}

function savedLocale() {
  try {
    return supportedLocale(window.localStorage.getItem(languageStorageKey))
  } catch (error) {
    return 'en'
  }
}

const i18n = new VueI18n({
  locale: savedLocale(),
  fallbackLocale: 'en',
  messages,
})

export function setLocale(locale) {
  const selectedLocale = supportedLocale(locale)
  i18n.locale = selectedLocale
  localize(selectedLocale)
  localizeFull(selectedLocale)
  document.documentElement.lang = selectedLocale
  try {
    window.localStorage.setItem(languageStorageKey, selectedLocale)
  } catch (error) {
    // Language switching still works when browser storage is unavailable.
  }
}

document.documentElement.lang = i18n.locale
localize(i18n.locale)
localizeFull(i18n.locale)

export default i18n
